import { useQuery } from 'react-query';
import { QueryKeys } from '@frontend/features/common/types';
import { fetchTravelBookingById } from '../queries';

/** El enlace resuelve una sola reserva; no depende de la página ni filtros del listado. */
export const useBookingNotificationTarget = (bookingId: string | null, agencyId: number, userId?: string) => {
  const validId = Boolean(
    bookingId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(bookingId),
  );
  const query = useQuery({
    queryKey: [QueryKeys.getTravelBookings, 'notification', agencyId, userId, bookingId],
    queryFn: () => fetchTravelBookingById(bookingId!),
    enabled: validId && Boolean(userId),
    retry: false,
  });
  return { ...query, invalidId: Boolean(bookingId && !validId) };
};
